/**
 * Created by kierangrosvenor on 25/05/2017.
 */

import axios from 'axios'
import config from '../../config'

import wrapper from 'axios-cache-plugin';

let postCache = wrapper(axios, {
  maxCacheSize: Infinity,
  ttl: 60000,
});

postCache.__addFilter(/permalink/);
postCache.__addFilter(/category/);
postCache.__addFilter(/categories/);

let LifeStyleApi = {
  /**
   *
   * @param page
   * @param perPage
   * @param termId
   * @param thumbnailSize
   * @returns {AxiosPromise}
   */
  getCategoryPosts(page = 1, perPage = 15, termId = 1, thumbnailSize = 'large') {
    return axios.get(config.apiUrl + 'life/category/items/', {
      params: {
        page: page,
        per_page: perPage,
        term_id: termId,
        size: thumbnailSize,
      }
    })
  },
  /**
   *
   * @param page
   * @param perPage
   * @param thumbnailSize
   * @returns {AxiosPromise}
   */
  getPosts(page = 1, perPage = 15, thumbnailSize = 'medium-400') {
    return axios.get(config.apiUrl + 'life/posts/', {
      params: {
        page: page,
        per_page: perPage,
        size: thumbnailSize
      }
    })
  },
  /**
   *
   * @returns {AxiosPromise}
   */
  getCategorys() {
    return axios.get(config.apiUrl + 'life/categories/');
  },
  /**
   *
   * @param slugId
   * @returns {AxiosPromise}
   */
  getCategory(slugId) {
    return postCache({
      url: config.apiUrl + 'life/category/' + slugId,
      method: 'GET'
    });
  },
  /**
   *
   * @param permalink
   * @param size
   * @returns {AxiosPromise}
   */
  getPost(permalink, size = 'large') {
    return postCache({
      url: config.apiUrl + 'life/post/permalink/' + permalink,
      method: 'GET',
      params: {
        size: size,
      }
    });
  },
  /**
   *
   * @param params
   * @returns {AxiosPromise}
   */
  getPostComments(params) {
    return axios.get(config.apiUrl + 'life/post/comments/' + params.post_id, {
      params: {
        page: params.page,
        page_size: params.page_size,
        type: params.type,
      }
    });
  },
  /**
   *
   * @param params
   * @returns {AxiosPromise}
   */
  likePostComment(model) {
    return axios.post(config.apiUrl + 'life/post/comment/like/', model);
  },
  /**
   *
   * @param post_id
   * @param limit
   * @returns {AxiosPromise}
   */
  getRecommendationsByPost(post_id, user_id, limit) {
    return axios.get(config.apiUrl + 'life/post/' + post_id + '/recommendations', {
      params: {
        user_id: user_id,
        limit: limit
      }
    });
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  addComment(model) {
    return axios.post(config.apiUrl + 'life/post/comment/', model);
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  updateComment(model) {
    return axios.put(config.apiUrl + 'life/post/comment/', model);
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  deleteComment(model) {
    return axios({
      method: 'delete',
      url: config.apiUrl + 'life/post/comment/',
      data: model,
      headers: {"Content-Type": "application/json"}
    })
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  favouritePost(model) {
    return axios.post(config.apiUrl + 'life/post/favourite/', model);
  },
  /**
   *
   * @param search
   * @param model
   * @returns {AxiosPromise}
   */
  getSearchPosts(search, model) {
    return axios.get(config.apiUrl + 'life/search/posts/', {
      params: {
        search: search,
        page: model.page,
        per_page: model.per_page,
        size: model.size
      }
    });
  },
  /**
   *
   * @returns {AxiosPromise}
   */
  getUserRecommendedPosts(size = 'large') {
    return axios.get(config.apiUrl + 'life/user/recommendations', {
      params: {
        size: size
      }
    });
  },
  /**
   *
   * @param post_id
   * @param size
   * @returns {AxiosPromise}
   */
  getSimilarPosts(post_id, size = 'large') {
    return axios.get(config.apiUrl + 'life/similarposts/' + post_id, {
      params: {
       size: size
      }
    })
  },
  getMyFavouritePosts(user_id, model) {
    return axios.get(config.apiUrl + 'life/user/favourites/' + user_id, {
      params: {
        page: model.page,
        per_page: model.per_page
      }
    })
  }
};

export default LifeStyleApi;




// WEBPACK FOOTER //
// ./src/api/LifeStyle/index.js